@if (question?.helpText || helpText) {
  <span class="no-margin no-padding display-inline-block" [popover]="{ text: text, position: position }">
    <svg-icon icon="icon-info" class="dark-gray" [ngClass]="{ 'red' : alert }"></svg-icon>
  </span>
}
